import { request } from '@/utils/request'
import type { ApiResult } from '@/api/common'
import type { MenuQueryParams, MenuInfo, MenuSaveParams } from '@/types/menu'
import type { PageInfo } from '@/types/user'

/**
 * 分页查询菜单列表
 */
export function getMenuList(params: MenuQueryParams) {
  return request<ApiResult<PageInfo<MenuInfo>>>({
    url: '/api/menu/list',
    method: 'get',
    params
  })
}

// 新增菜单接口
export const addMenu = (data: MenuSaveParams) => {
  return request({
    url: '/api/menu/add',
    method: 'post',
    data
  })
}

// 修改菜单
export function updateMenu(id: number, data: MenuSaveParams) {
  return request<void>({
    url: `/api/menu/update/${id}`,
    method: 'PUT',
    data
  })
}

// 删除菜单
export function deleteMenu(id: number) {
  return request<void>({
    url: `/api/menu/delete/${id}`,
    method: 'DELETE'
  })
}

// 获取当前学校菜单列表
export const getSchoolMenuList = () => {
  return request<ApiResult<PageInfo<MenuInfo>>>({
    url: '/api/menu/school/list',
    method: 'get',
  })
}